module.exports = __webpack_public_path__ + "media/images/ac_templates/201/blkht-25ea974a20b152dee72b9e6457b9d8df.jpg";